import { ConversationParticipant } from '@centecomm/portal-service';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { conversationsSelectors } from 'State';
import { ParticipantLeftConversation as ParticipantLeftConversationEvent } from 'Types/Conversations/Events';
import styles from '../conversations.module.css';

interface ParticipantLeftConversationProps {
    conversationId: number;
    event: ParticipantLeftConversationEvent;
}

function ParticipantLeftConversation({
    conversationId,
    event,
}: ParticipantLeftConversationProps): React.ReactElement<ParticipantLeftConversationProps> {
    useTranslation(['conversationsFeature']);
    const { userId } = event;

    const user: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, userId),
    );

    return (
        <div className={styles.SystemItem}>
            <p>
                {user ? (
                    <Trans
                        i18nKey="conversationsFeature:events.participantLeftConversation.usernameLeft"
                        components={{
                            span: <span />,
                        }}
                        values={{ username: user.userName }}
                    />
                ) : (
                    <Trans
                        i18nKey="conversationsFeature:events.participantLeftConversation.unknownUserLeft"
                        components={{
                            span: <span />,
                        }}
                    />
                )}
            </p>
        </div>
    );
}

export default ParticipantLeftConversation;
